import config from '../../../config/config';
import getRequest from '../base/get';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Fetch the Accounts list with pagination
   * @param {any} query - The query
   */
  fetchUsers: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/cpo/v1/charging-transaction/list-charging-transactions`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch the transaction list for export
   * @param {any} query - The query
   */
  fetchTransactionExport: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/cpo/v1/super-admin/list-charging-transactions/export-data`,
      {
        ...parameters,
      },
    );
  },

  /**
   * Fetch approved station API
   * @returns {any} A promise that resolves with the list filters
   */
  fetchListFilters: () => {
    return getRequest(`${config.reportApiUrl}api/cpo/v1/charging-transaction/list-filters`);
  },
  /**
   * Fetch transaction by Id
   * @param {any} id - The transaction ID
   * @returns {any} A promise that resolves with the transaction info
   */
  fetchTransactionById: (id: string) => {
    return getRequest(
      `${config.reportApiUrl}api/cpo/v1/charging-transaction/consumer-transaction-info/${id}`,
    );
  },
  /**
   * Fetch transaction by Id
   * @param {any} query - The query parameters
   * @returns {any} A promise that resolves with the revenue payout
   */
  fetchRevenuePayout: (query: QueryParameters = {}) => {
    const parameters = { ...query };
    return getRequest(`${config.transactionApiUrl}api/super-admin/v1/revenue-payout/`, {
      ...parameters,
    });
  },
  /**
   * get for the Revenue Payout  Total
   */
  getRevenuePayoutAmount: (): Promise<any> => {
    return getRequest(
      `${config.transactionApiUrl}api/super-admin/v1/revenue-payout/transferred-total`,
    );
  },
  /**
   * Fetch Revenue getStripeHistoryExport API for export
   * @param {any} query - The query parameters
   * @returns {any} A promise that resolves with the exported data
   */
  getStripeHistoryExport: (query: QueryParameters = {}) => {
    const parameters = { ...query };
    return getRequest(`${config.transactionApiUrl}api/super-admin/v1/revenue-payout/export-data`, {
      ...parameters,
    });
  },
};
